import React, { useRef } from 'react';
import uniqueId from 'lodash/uniqueId';
import { PopperDropdownManager, PopperDropdownToggle } from '../../PopperDropdownLayout';
import StandardDropdownMenu from '../StandardDropdown/StandardDropdownMenu';
import { useDropdownItems } from '../../hooks/useDropdownItems';
import ConditionalWrapper from '../../../ConditionalWrapper';
import IconButton from '../../legacy/IconButton';
/**
 * A button containing some `children` that shows a context menu style dialog on click
 */ const IconButtonWithContextMenu = ({ className, items, children, contextMenuClassName, disabled, wrapper, withButton, noIconHoverEffect, biData, onOpenBiData, onCloseBiData, usePortal = true, placement = 'bottom-end', offsetModifier, isInPopup, popperClassName, onOpen, onClose, onToggle, onClick, 'aria-label': ariaLabel })=>{
    const { filteredItems } = useDropdownItems(items);
    const { current: id } = useRef(uniqueId('dropdown'));
    return /*#__PURE__*/ React.createElement(PopperDropdownManager, {
        isInPopup: isInPopup,
        onOpen: onOpen,
        onClose: onClose,
        onToggle: onToggle,
        disabled: disabled
    }, /*#__PURE__*/ React.createElement(ConditionalWrapper, {
        condition: !!wrapper,
        wrap: wrapper
    }, /*#__PURE__*/ React.createElement(PopperDropdownToggle, {
        biData: biData,
        onOpenBiData: onOpenBiData,
        onCloseBiData: onCloseBiData,
        className: className,
        "aria-label": ariaLabel
    }, /*#__PURE__*/ React.createElement(ConditionalWrapper, {
        condition: withButton,
        wrap: (child)=>/*#__PURE__*/ React.createElement(IconButton, {
                onClick: onClick,
                noHoverEffect: noIconHoverEffect,
                disabled: disabled
            }, child)
    }, children)), /*#__PURE__*/ React.createElement(StandardDropdownMenu, {
        id: id,
        role: "menu",
        menuScrollable: true,
        className: contextMenuClassName,
        popperClassName: popperClassName,
        items: filteredItems,
        placement: placement,
        offsetModifier: offsetModifier,
        usePortal: usePortal
    })));
};
IconButtonWithContextMenu.displayName = 'IconButtonWithContextMenu';
export default IconButtonWithContextMenu;
